import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class UsersEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      actual_password: '',
      new_password: '',
      re_new_password: '',
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.edit = this.edit.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  edit(event) {
    event.preventDefault();
    var datasave = {
      actual_password: this.state.actual_password,
      new_password: this.state.new_password,
      re_new_password: this.state.re_new_password,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/usuario/alterar/senha', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.Usuarios.AlteracaoDeSenha.titulo}</h3>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="form-group">
          <label>{this.locale.Usuarios.AlteracaoDeSenha.formulario.SenhaAtual}</label>
          <div className="input-group">
            <div className="input-group-addon"><i className="fa fa-fw fa-lock"></i></div>
            <input type="password" name="actual_password" className="form-control" placeholder={this.locale.Usuarios.AlteracaoDeSenha.formulario.placeholder.SenhaAtual} value={this.state.actual_password} onChange={this.handleChange.bind(this, 'actual_password')} />
          </div>
        </div>
        <div className="form-group">
          <label>{this.locale.Usuarios.AlteracaoDeSenha.formulario.NovaSenha}</label>
          <div className="input-group">
            <div className="input-group-addon"><i className="fa fa-fw fa-lock"></i></div>
            <input type="password" name="actual_password" className="form-control" placeholder={this.locale.Usuarios.AlteracaoDeSenha.formulario.placeholder.NovaSenha} value={this.state.new_password} onChange={this.handleChange.bind(this, 'new_password')} />
          </div>
        </div>
        <div className="form-group">
          <label>{this.locale.Usuarios.AlteracaoDeSenha.formulario.RepitaANovaSenha}</label>
          <div className="input-group">
            <div className="input-group-addon"><i className="fa fa-fw fa-lock"></i></div>
            <input type="password" name="actual_password" className="form-control" placeholder={this.locale.Usuarios.AlteracaoDeSenha.formulario.placeholder.RepitaANovaSenha} value={this.state.re_new_password} onChange={this.handleChange.bind(this, 're_new_password')} />
          </div>
        </div>
        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.salvar}</button>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default UsersEdit;



// WEBPACK FOOTER //
// ./src/Components/Users/UsersEditPassword.js